module.exports = __webpack_public_path__ + "static/media/17_Account_My Preferences.eb8a12e9.jpg";